module.exports = __webpack_public_path__ + "img/product1.b6f4e5bf.jpeg";